import { render, staticRenderFns } from "./bomInformation.vue?vue&type=template&id=b2411418&"
import script from "./bomInformation.vue?vue&type=script&lang=js&"
export * from "./bomInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2411418')) {
      api.createRecord('b2411418', component.options)
    } else {
      api.reload('b2411418', component.options)
    }
    module.hot.accept("./bomInformation.vue?vue&type=template&id=b2411418&", function () {
      api.rerender('b2411418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mes/components/productionProgress/bomInformation.vue"
export default component.exports